export default __webpack_public_path__ + "static/media/computer-laptop.a2b07522.glb";